import { request } from '@umijs/max';
// import { config } from '@/utils/config';
// import qs from 'qs';

/**
 *
 * @param data 
 * @returns
 */
export const getTicketPage = async (params?: any) => {
  return request('/api/community/ticket/record/page', {
    method: 'get',
    params,
  });
};


/**
 * 流转记录
 */

export const getTicketFlowDetail = async (params: any) => {
  return request(
    `/api/community/ticket/record/flow/list`,
    {
      method: 'get',
      params,
    },
  );
};


/**
 * 详情 /ticket/management/${sequenceNbr}
 */

export const getTicketDetail = async (sequenceNbr?: any) => {
  return request(`/api/community/ticket/record/${sequenceNbr}`, {
    method: 'get',
  });
};

/**
 * 业主端撤回接口community/ticket/record/:sequenceNbr/ticketstatus/withdrawn

 */

export const withdrawnTicket = async (sequenceNbr?: any) => {
  return request(`/api/community/ticket/record/${sequenceNbr}/ticketstatus/withdrawn`, {
    method: 'put'
  });
};

/**
 * 业主端创建工单
 * 
 */
export const addTicketRecord = async (data?: any) => {
  return request(`/api/community/ticket/record`, {
    method: 'post',
    data
  });
};

/**
 * 业主端修改工单community/ticket/record/:sequenceNbr
 */

export const updateTicketRecord = async (data?: any) => {
  return request(`/api/community/ticket/record/${data.sequenceNbr}`, {
    method: 'put',
    data
  });
};

/**
 * 业主端 --- 确认工单有偿ticket/record/confirmation/:sequenceNbr
 */

export const confirmationTicketFee = async (sequenceNbr?: any) => {
  return request(`/api/community/ticket/record/confirmation/${sequenceNbr}`, {
    method: 'put'
  });
};